<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <div class="claims">
    <loading-component>
      <template #content>
        <div class="flex flex-col gap-4">
          <div class="self-end">
            <button-component fa-icon="fa-regular fa-plus"
                              background-color="bg-green-600"
                              @click="$router.push(`/claims/create`)">
            </button-component>
          </div>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            <card-component v-for="(claim, index) of claimsStore.getClaims" v-bind:key="index">
              <template v-slot:body>
                <div class="flex flex-row gap-4 items-center break-all">
                  <div class="flex flex-col">
                    <h2 class="card-title">{{ claim.name }}</h2>

                    <div class="flex flex-col text-gray-400 text-sm">
                      <div>Identifier: {{ claim.identifier }}</div>
                      <div>Beschreibung: {{ claim.description }}</div>
                    </div>
                  </div>
                </div>
              </template>

              <template v-slot:footer>
                <button-component fa-icon="fa-regular fa-pencil" @click="$router.push(`/claims/${claim.identifier}`)" />
                <delete-component @delete="deleteClaim(claim.identifier)" />
              </template>
            </card-component>
          </div>
        </div>
      </template>
    </loading-component>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useClaimsStore } from "@/stores/claims";
import CardComponent from "@/components/CardComponent";
import LoadingComponent from "@/components/LoadingComponent";
import ButtonComponent from "@/components/ButtonComponent";
import DeleteComponent from "@/components/DeleteComponent";
import Notifications from "@auth/vue-share/utility/notifications";
import logger from "@auth/vue-share/utility/logger";

export default {
  name: "ClaimsView",
  components: { DeleteComponent, ButtonComponent, LoadingComponent, CardComponent },
  created() {
    this.claimsStore.fetchClaims();
  },
  computed: {
    ...mapStores(useClaimsStore)
  },
  methods: {
    deleteClaim(claim) {
      this.claimsStore.deleteClaim(claim).then(() => {
        Notifications.success("Claim erfolgreich gelöscht");
      }).catch((error) => {
        Notifications.error("Claim konnte nicht gelöscht werden");
        logger.error("[CLAIM]", error);
      });
    }
  }
};
</script>

<style scoped>

</style>